export default __webpack_public_path__ + "static/media/sales.71b939cf.png";